import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from './common/ThemeContext';
import AppRoute from './routes/AppRoute';

const App = () => {
  return (
    <ThemeProvider>
      <Router>
        <AppRoute />
      </Router>
    </ThemeProvider>
  );
};

export default App;
